export default __webpack_public_path__ + "static/media/red_hat.09586b9d.png";